// google-maps-loader.service.ts
import { Injectable } from '@angular/core';
import { config } from '@app/core/app.config';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loader: Promise<void> | null = null;
  private readonly apiKey = config.GOOGLE_API_KEY;

  load(): Promise<void> {
    if (this.loader) return this.loader;

    this.loader = new Promise((resolve, reject) => {
      if ((window as any).google?.maps) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=__onGoogleMapsLoaded`;
      script.async = true;
      script.defer = true;

      (window as any).__onGoogleMapsLoaded = () => resolve();

      script.onerror = reject;

      document.head.appendChild(script);
    });

    return this.loader;
  }
}
